import { useEffect, useState } from "react";
import SignUp from "./signup/SignUp";
import AnnualUpgrade from "./signup/AnnualUpgrade";
import { subscribe, unsubscribe } from "../shared/events";
import posthogClient from "../shared/posthogClient";
import ModalManager from "./ModalManager";

export default function Global() {

  const [User, SetUser] = useState(null)

  useEffect(() => {

    subscribe("userBuilt", (e) => {
      const { subscription, ...user } = e.detail.user;
      SetUser(e.detail.user);
      if (user.email) {
        const properties = { subscribed: !!subscription };
        if (subscription) {
          properties.tier = subscription.tier;
          properties.period = subscription.period;
        }
        posthogClient.identify(user.email, properties);
      }
    });

    return () => {
      unsubscribe("userBuilt", () => SetUser(null));
    }

  }, []);

  return (
    <>
      {User &&
        <>
          <SignUp user={User} />
          <AnnualUpgrade user={User} />
        </>
      }
      <ModalManager />
    </>
  )
}